import { render } from "./SummarizedContractInfo.vue?vue&type=template&id=2f30e3d2&ts=true"
import script from "./SummarizedContractInfo.vue?vue&type=script&lang=ts"
export * from "./SummarizedContractInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__